import { feishuService } from '@/api/';
import { useUserStore } from '@/store';
// import { ref } from 'vue';
// import { tools } from '@/utils/tools';
export default async function useFeishuSDK(options = {}) {
  // const myComponent = ref();
  const cb = options.cb;
  const isComponent = options.isComponent;
  const openId = options.openId;
  const dom = options.dom || document.querySelector('#userProfile');
  const userStore = useUserStore();
  // dom.innerHtml = ''
  // 调用config接口的当前网页url
  const url = encodeURIComponent(location.href.split('#')[0]);
  // 向接入方服务端发起请求，获取鉴权参数（appId、timestamp、nonceStr、signature）
  try {
    // const json = await feishuService.getWebComponentAuth({url:url});
    const json = await feishuService.getFeishuAuth({ url: url });
    console.log(18, '获取签名', json.result);
    const res = json.result;
    if (!json.error && res) {
      if (isComponent) {
        // dom.innerHTML = '';
        console.log('组件', userStore.userInfo?.feishuOpenId);
        // const viewUser = await feishuService.getUserOpenId({ userId });
        // console.log(40, viewUser, viewUser.result?.openId);
        // 获取用户的openId
        return window.webComponent
          .config({
            openId: userStore.userInfo?.feishuOpenId, // 当前登录用户的open id，要确保与生成 signature 使用的 user_access_token 相对应，使用 app_access_token 时此项不填。注意：仅云文档组件可使用app_access_token
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            url, // 第3步参与加密计算的url
            jsApiList: ['user_profile'] // 指定要使用的组件列表，请根据对应组件的开发文档填写。如云文档组件，填写['DocsComponent']
            // locale,// 指定组件的国际化语言：en-US-英文、zh-CN-中文、ja-JP-日文
          })
          .then(async (res) => {
            console.log(30, res, openId);
            // 可以在这里进行组件动态渲染
            // if (!viewUser.error && viewUser.result?.openId) {
            window.addProfileDynamical = function () {
              // 动态渲染，返回组件实例。
              window.matrixProfile = window.webComponent.render(
                'UserProfile',
                {
                  openId // 要展示哪个用户的成员名片
                },
                dom
                // 将组件挂在到哪个元素上
                // document.querySelector(dom ||'body')
                // document.querySelector('body') // 将组件挂在到哪个元素上
              );
            };
            window.removeProfileDynamical = function () {
              // 销毁组件
              window.matrixProfile?.unmount();
            };

            console.log(4158, window);
            // 捕获组件内部错误
            window.webComponent.onError(function (error) {
              console.error('custom error:', error);
            });

            // 捕获 sdk 鉴权错误
            window.webComponent.onAuthError(function (error) {
              console.error('auth error callback', error);
            });
            // }
          });
      }

      console.log('start apiAuth');
      if (!window.h5sdk) {
        console.log('invalid h5sdk');
        return;
      }
      // 通过error接口处理API验证失败后的回调
      window.h5sdk.error((err) => {
        throw ('h5sdk error:', JSON.stringify(err));
      });
      // 调用config接口进行鉴权
      window.h5sdk.config({
        appId: res.appId,
        timestamp: res.timestamp,
        nonceStr: res.nonceStr,
        signature: res.signature,
        jsApiList: [],
        //鉴权成功回调
        onSuccess: (res) => {
          console.log(`config success: ${JSON.stringify(res)}`);
        },
        //鉴权失败回调
        onFail: (err) => {
          throw `config failed: ${JSON.stringify(err)}`;
        }
      });
      // 完成鉴权后，便可在 window.h5sdk.ready 里调用 JSAPI
      window.h5sdk.ready(() => {
        // window.h5sdk.ready回调函数在环境准备就绪时触发
        // 调用 getUserInfo API 获取已登录用户的基本信息，详细文档参见https://open.feishu.cn/document/uYjL24iN/ucjMx4yNyEjL3ITM
        cb?.();
      });
    }
  } catch (error) {
    console.log(error);
  }
}
